<template>
  <div v-if="visible" class="referral-banner" role="status">
    <v-icon size="20" color="#184679">mdi-account-tie</v-icon>
    <div class="referral-banner__text">
      <strong>Assisted by {{ agentName }}</strong>
      <span>Your quote will be linked to this agent for support and commission.</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReferralAgentBanner',
  computed: {
    ...mapGetters('referral', ['hasValidReferral', 'referralAgencyName']),
    visible() {
      return this.hasValidReferral && !!this.referralAgencyName;
    },
    agentName() {
      return this.referralAgencyName;
    },
  },
};
</script>

<style scoped>
.referral-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 10px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1e3a5f;
}

.referral-banner__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.85rem;
  line-height: 1.35;
}

.referral-banner__text strong {
  font-size: 0.9rem;
}

.referral-banner__text span {
  color: #475569;
}
</style>
